import { MorphemeInfoPanelTabContent } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._components.morpheme-info-panel-tab-content";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { MorphemeInfoPanelContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._context";
import { useMorphemeInfoPanelCompositionCompoundsSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.composition.__views.compounds";
import { useMorphemeInfoPanelCompositionCharactersSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.composition.__views.characters";
import type {
  ReferenceGraphemeMorphemeSlice,
  ReferenceWordMorphemeSlice,
} from "@-/dev.improve.haniverse.lib.morpheme.entities";

export function MorphemeInfoPanelCompositionTab() {
  const [infoBackCardSlice] = useContextSelectors(
    MorphemeInfoPanelContext,
    (c) => c.infoBackCardSlice.data,
  );
  if (infoBackCardSlice.morphemeType === "word") {
    return <MorphemeInfoPanelCompositionWordTab wordCard={infoBackCardSlice} />;
  }
  return <MorphemeInfoPanelCompositionGraphemeTab graphemeCard={infoBackCardSlice} />;
}

function MorphemeInfoPanelCompositionGraphemeTab({
  graphemeCard,
}: {
  graphemeCard: ReferenceGraphemeMorphemeSlice;
}) {
  const [setIsScrolled] = useContextSelectors(MorphemeInfoPanelContext, (c) => c.setIsScrolled);
  const compounds = useMorphemeInfoPanelCompositionCompoundsSection({ graphemeCard });
  return (
    <MorphemeInfoPanelTabContent
      groupTitle="Components"
      onScrolledChange={setIsScrolled}
      sections={[compounds]}
    />
  );
}

function MorphemeInfoPanelCompositionWordTab({
  wordCard,
}: {
  wordCard: ReferenceWordMorphemeSlice;
}) {
  const [setIsScrolled] = useContextSelectors(MorphemeInfoPanelContext, (c) => c.setIsScrolled);
  const characters = useMorphemeInfoPanelCompositionCharactersSection({ wordCard });
  return (
    <MorphemeInfoPanelTabContent
      groupTitle="Components"
      onScrolledChange={setIsScrolled}
      sections={[characters]}
    />
  );
}
